import { FormControl, ValidationErrors } from '@angular/forms';

export function emailValidator(
  control: FormControl | string
): ValidationErrors | null {
  let value: string | null = null;
  // if control is string, it's a value
  if (typeof control === 'string') {
    value = control;
  }

  // if control is FormControl, it's a control
  if (control instanceof FormControl) {
    value = control.value;
  }

  // empty fields is still valid
  if (!value) return null;

  return /(^$|[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?)/.test(
    value
  )
    ? null
    : { email: true };
}
